import * as React from "react";
import {Navbar, NavbarBrand, NavbarCollapse, NavbarLink, NavbarToggle } from "flowbite-react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

const Header = () => {
  return (
    <Navbar fluid rounded className="container display rounded-none border-b-1 border-primary">
      <Link to="/">
        <span className="self-center whitespace-nowrap text-xl">
          <span className="text-gray-600">Mind</span>
          <span className="font-semibold text-primary">Pulse</span>
        </span>
      </Link>
      <div className="flex md:order-2">
        <a href="/patients/sign_in">
          <Button variant="outline" className="border-primary/90 hover:bg-primary text-primary hover:text-white rounded-full h-auto text-md">
            Login
          </Button>
        </a>
        <NavbarToggle />
      </div>
      <NavbarCollapse>
        <NavbarLink className="text-lg text-gray-500 md:hover:text-primary" href="/therapist_directory">Find a Therapist</NavbarLink>
        <NavbarLink className="text-lg text-gray-500 md:hover:text-primary" href="/assessments">Assessment</NavbarLink>
        <NavbarLink className="text-lg text-gray-500 md:hover:text-primary" href="/landing/therapists">For Therapists</NavbarLink>
        <NavbarLink className="text-lg text-gray-500 md:hover:text-primary" href="/landing/events">Events</NavbarLink>
      </NavbarCollapse>
    </Navbar>
  );
}

export default Header;
